const singleWalletEnum = ["77lottery", "mg", "saba", "jollysport", "winlottery"];

export default singleWalletEnum;
